import React, { useMemo, useRef } from 'react';
import { EventEmitterService } from 'js/services/eventEmitter.service';

import { EmitterContext } from './context';

const CONDITION_EVENT = 'CONDITION_EVENT';

const useApi = emitter => useMemo(() => ({
    triggerCondition: condition => emitter.trigger(CONDITION_EVENT, condition),
    addConditionListener: callback => emitter.on(CONDITION_EVENT, callback),
    removeConditionListener: callback => emitter.off(CONDITION_EVENT, callback)
}), [emitter]);

export const Emitter = ({ children }) => {
    const { current: emitter } = useRef(new EventEmitterService());
    const api = useApi(emitter);

    return (
        <EmitterContext.Provider value={api}>
            {children}
        </EmitterContext.Provider>
    );
};
